import { applyMiddleware, createStore } from 'redux';
import { analyticsMiddleware } from '../shared/analyticsManager';
import reducer from './combinedReducers';

// eslint-disable-next-line import/prefer-default-export
export const setupStore = () => {
  return createStore(reducer, applyMiddleware(analyticsMiddleware));
};
